import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./Federal.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
import Principle from "Components/Cards/Cards";
import Icon1 from "Assets/About/principle_1.png";
import Icon2 from "Assets/About/principle_2.png";
import Icon3 from "Assets/About/principle_3.png";
const Card = [
    {
        icon: Icon1,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We bring order to chaos",
    },
    {
        icon: Icon2,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We do it right the first time.",
    },
    {
        icon: Icon3,
        Content:
            "At Executive Tax and Accounting Services. there are no excuses. If you need a service provided, we will find a way to complete. it, Our paperwork is accurate and always up to date.",
        heading: "You need it? We provide it.",
    },
];
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Terms and conditions</h3>
                </header>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div className={AboutClasses["content"]}>
                        <p>Effective Date: 01/01/2025</p>
                        <p>
                            Thank you for using the payment gateway services
                            provided by Serene Tax LLC. By using this service,
                            you agree to comply with these terms and conditions.
                            Please read them carefully before making a payment.
                        </p>
                        <h4>1. Payment Authorization</h4>
                        <p>
                            By initiating a payment through our gateway, you
                            authorize Serene Tax LLC to process the transaction
                            via our secure payment system. You confirm that the
                            payment method belongs to you or that you are an
                            authorized user of the payment method.
                        </p>
                        <h4>2. Secure Transactions</h4>
                        <p>
                            We prioritize the security of your payment
                            information and employ industry-standard encryption
                            protocols. While we take every precaution, Serene
                            Tax LLC is not responsible for unauthorized access
                            due to user negligence or external breaches beyond
                            our control.
                        </p>
                        <h4>3. Payment Processing</h4>
                        <ul>
                            <li>
                                Payments made through the gateway are processed
                                in U.S. dollars (USD).
                            </li>
                            <li>
                                Payments may take up to 1-2 business days to
                                reflect as processed.
                            </li>
                            <li>
                                You will receive a confirmation email or receipt
                                upon successful payment.
                            </li>
                        </ul>
                        <h4>4. Fees and Charges</h4>
                        <ul>
                            <li>
                                Any applicable service fees, taxes, or other
                                charges will be displayed at the time of
                                payment.
                            </li>
                            <li>
                                You are responsible for any additional fees
                                imposed by your bank or credit card provider.
                            </li>
                        </ul>
                        <h4>5. Refund and Cancellation Policy</h4>
                        <ul>
                            <li>
                                Refund requests must be submitted in writing to
                                support@serenetax.com and are subject to our
                                Refund Policy.
                            </li>
                            <li>
                                Refunds, if approved, will be processed to the
                                original payment method within 7-10 business
                                days.
                            </li>
                            <li>
                                Cancellation of services must be initiated prior
                                to the start of the service to be eligible for
                                any refund consideration.
                            </li>
                        </ul>
                        <h4>
                            6. Compliance with Virginia State and Federal Laws
                        </h4>
                        <p>
                            By using this payment gateway, you agree to comply
                            with all applicable laws, including Virginia state
                            regulations and federal laws of the United States.
                        </p>
                        <h4>7. Dispute Resolution</h4>
                        <p>
                            For any disputes related to payments, you must
                            notify us in writing at{" "}
                            <span
                                style={{
                                    textDecoration: "underline",
                                    color: "blue",
                                }}>
                                support@serenetax.com
                            </span>{" "}
                            within 30 days of the transaction. We will work to
                            resolve the issue promptly.
                        </p>
                        <h4>8. Prohibited Uses</h4>
                        <p>You agree not to use our payment gateway for:</p>
                        <ul>
                            <li> Any fraudulent or illegal transactions.</li>
                            <li>
                                Payments unrelated to the services provided by
                                Serene Tax LLC.
                            </li>
                            <li>
                                Activities that violate local, state, or federal
                                laws.
                            </li>
                        </ul>
                        <h4>9. Limitation of Liability</h4>
                        <p>Serene Tax LLC will not be held liable for:</p>
                        <ul>
                            <li>
                                Unauthorized use of your payment credentials.
                            </li>
                            <li>
                                Delays or failures caused by third-party payment
                                processors.
                            </li>
                            <li>
                                Losses or damages arising from technical
                                malfunctions or events beyond our control.
                            </li>
                        </ul>
                        <h4>10. Modifications to Terms</h4>
                        <p>
                            We reserve the right to update these terms at any
                            time. Changes will be effective immediately upon
                            posting on this page. Please review these terms
                            periodically for updates.
                        </p>
                        <h4>11. Governing Law</h4>
                        <p>
                            These Terms and Conditions are governed by the laws
                            of the State of Virginia. Any disputes shall be
                            resolved in accordance with Virginia state laws and
                            applicable federal regulations.
                        </p>
                        <h4>12. Contact Information</h4>
                        <p>
                            For any questions or concerns regarding these terms
                            or your payments, please contact us:
                        </p>
                        <ul>
                            <li>
                                Email:{" "}
                                <span
                                    style={{
                                        textDecoration: "underline",
                                        color: "blue",
                                    }}>
                                    support@serenetax.com/ contact@serenetax.com
                                </span>
                            </li>
                            <li>
                                <b>Phone</b>
                                +1 (262) 735-8874/ +1 (262) 735-8875
                            </li>
                            <li>
                                <b>Mailing Address</b> 42707 Wardlaw Ter,
                                Ashburn, Virginia, 20147, USA.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
